import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Card } from '../components/ui';

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="max-w-lg mx-auto px-4 py-16">
      <Card className="text-center animate-fade-in">
        <div className="w-16 h-16 rounded-full bg-red-500/20 flex items-center justify-center mx-auto mb-6">
          <svg className="w-8 h-8 text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
          </svg>
        </div>
        <h1 className="font-display text-2xl font-bold text-gray-100 mb-2">Pago cancelado</h1>
        <p className="text-gray-400 mb-8">
          El pago fue cancelado o no se completó. Tus productos siguen en el carrito.
        </p>
        <div className="flex gap-3 justify-center">
          <Button onClick={() => navigate('/cart')}>Volver al carrito</Button>
          <Button variant="outline" onClick={() => navigate('/')}>Ir al catálogo</Button>
        </div>
      </Card>
    </div>
  );
}
